export default __webpack_public_path__ + "static/media/webdevise.fb271b95.png";